/* --------------------------------------------------------------------------------------
   categoriesPopup.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const categoriesPopupComponent = {
  template: `
    <action-bar id="categories-action-bar" title="{{ 'CATEGORY' | translate }}" ok="vm.ok()" cancel="vm.cancel()" disable-ok="!vm.selectedcategory"></action-bar>
    <div xw-popup display="vm.display" custom-action-bar="#categories-action-bar">
      <table xw-table class="full-width-popup-table">
        <tr ng-repeat="category in vm.categories" ng-click="vm.select(category)" ng-class="{'ui-state-selected': category == vm.selectedcategory}">
          <td>{{category.Name}}</td>
        </tr>
      </table>
    </div>
    `,
  bindings: {
    display: '=',
    category: '='
  },
  controllerAs: 'vm',
  controller: class categoriesPopupController {
    /* @ngInject */
    constructor(commonService, scanService) {
      this.commonService = commonService
      this.scanService = scanService
    }
    $onInit() {
      this.categories = this.scanService.categories
      //fix this
      if (this.category)
        this.selectedcategory == this.category
    }
    select(category) {
      this.selectedcategory = category
      this.commonService.updateView()
    }
    ok() {
      this.category = angular.copy(this.selectedcategory)
      this.selectedcategory = null
      this.display = false
      this.commonService.updateView()
    }
    cancel() {
      this.display = false
      this.commonService.updateView()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/components/categoriesPopup.component.js